import React from 'react'
import '../../Styles/Profle/Settings.css'
import api from '../../api.js'
import { useNavigate } from 'react-router-dom';

function Settings() {
  const navigate = useNavigate();
  const accessToken = localStorage.getItem("accessToken");
  console.log(accessToken);


const  handleDeleteButton = async () => {
  const confirmDelete = window.confirm("Are you sure you want to Permanently delete your account? Once after Deleting your Account all data will be Deleted.");
  console.log("don")
  if (!confirmDelete) return; // If user cancels, exit the function
console.log("don")
  try {
    console.log("accessToken",accessToken)
    const res = await api.delete(`/user_api/delete-account?access_token=${JSON.parse(accessToken)}`);
    console.log("don",res)
    console.log(res.data.status);
    if (res.data.status === "success") {
      window.alert("Your account has been deleted successfully.");
      localStorage.removeItem(accessToken);
      navigate("/");
    }
  } catch (err) {
    console.log("Error: ",err);
    window.alert("An error occurred while deleting your account.");
  }
};

  return (
    <div className='Security_settings'>
      <h3>Security Settings</h3>
      <div className='Security_settings_div rounded shadow'>
        <button className='btn ' onClick={ handleDeleteButton } style={{ backgroundColor: "tomato", padding: "5px 10px", borderRadius: "5px" }}>Delete Account</button>
      </div>
    </div>
  )
}

export default Settings